// extracted by mini-css-extract-plugin
export var contentBody = "_3p-9";
export var headerImage = "_3p-2";
export var imageButton = "_3p-7";
export var imageButtonIcon = "_3p-8";
export var imageHeader = "_3p-4";
export var imageHeaderText = "_3p-5";
export var imageOverlay = "_3p-3";
export var imageTitle = "_3p-6";
export var imageWrapper = "_3p-1";
export var taskList = "_3p-a";
export var widget = "_3p-0";